import React from 'react';

export interface PageTab {
  id: string;
  label: string;
}

interface PageTabsProps {
  tabs: PageTab[];
  active: string;
  onChange: (id: string) => void;
}

const PageTabs: React.FC<PageTabsProps> = ({ tabs, active, onChange }) => (
  <div role="tablist" className="flex gap-1 border-b border-gray-200 mb-6">
    {tabs.map((tab) => (
      <button
        key={tab.id}
        type="button"
        role="tab"
        aria-selected={active === tab.id}
        onClick={() => onChange(tab.id)}
        className={
          active === tab.id
            ? 'px-4 py-2 text-sm font-semibold text-blue-600 border-b-2 border-blue-600 -mb-px'
            : 'px-4 py-2 text-sm font-medium text-gray-500 hover:text-gray-800'
        }
      >
        {tab.label}
      </button>
    ))}
  </div>
);

export default PageTabs;
